module.exports = __webpack_public_path__ + "static/media/user-02.735866d1.jpg";